module.exports = __webpack_public_path__ + "img/Protractor-03.ec072528.png";